<main class="flex-1 w-full pt-16 bg-background-light dark:bg-background-dark dark:text-white">
  <!-- <div class="relative h-64 md:h-80 w-full overflow-hidden">
    <img alt="Abstract background image with data visualization elements" class="w-full h-full object-cover object-center" src="https://lh3.googleusercontent.com/aida-public/AB6AXuD2fKcsDHBTfZKDtAfqs4HhV9P7vQ8jMabsGfH6OfVSRtzHnmF1T2J8VXOIPh043HOqXPJb8VKMk7D2FuCyySLDG6f1ToTwzUL_oex4ZG1uWJoHYfu9fuhbb8OMwYQa6ypC6XzMe0q0o4AIYFlOw_uPHkGUkTD1zlpA4hyGx8t0SqDP_09C0YdDl7F7b82Br8PVXFCcVl6Vmb6CG2kEbrKmvZVqCUCDKycEt3lDvRqWyD9l1yUtT47SGg_UJnxsqmOjj477wKN-yZE"/>
    <div class="absolute inset-0 bg-gradient-to-t from-background-light dark:from-background-dark via-background-light/30 dark:via-background-dark/30 to-transparent"></div>
    <div class="absolute inset-0 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div class="text-center">
        <h1 class="text-3xl sm:text-4xl lg:text-5xl font-extrabold font-display text-gray-800 dark:text-white tracking-tight">Unlock Your Product Potential</h1>
        <p class="mt-4 text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">Your central hub for all product information, tutorials, and resources.</p>
      </div>
    </div>
  </div> -->
  <div class="px-4 sm:px-6 lg:px-8 py-8">
    <div class="flex flex-col gap-10">
      <div class="flex items-center justify-between">
        <h3 class="text-2xl font-bold font-display text-gray-700 dark:text-white">Project Overview</h3>
        <!-- <div class="flex gap-3">
          <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-lg bg-card-light dark:bg-card-dark border border-gray-200 dark:border-gray-700/50 px-4 hover:border-primary dark:hover:border-primary hover:text-primary transition-colors group shadow-sm">
            <p class="text-gray-700 dark:text-gray-300 text-sm font-medium leading-normal group-hover:text-primary">Category</p>
            <span class="material-symbols-outlined text-gray-500 dark:text-gray-400 text-lg group-hover:text-primary">expand_more</span>
          </button>
          <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-lg bg-card-light dark:bg-card-dark border border-gray-200 dark:border-gray-700/50 px-4 hover:border-primary dark:hover:border-primary hover:text-primary transition-colors group shadow-sm">
            <p class="text-gray-700 dark:text-gray-300 text-sm font-medium leading-normal group-hover:text-primary">Technology</p>
            <span class="material-symbols-outlined text-gray-500 dark:text-gray-400 text-lg group-hover:text-primary">expand_more</span>
          </button>
        </div> -->
      </div>
      <div class="">
        <app-product-card></app-product-card>
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div class="lg:col-span-2 flex flex-col gap-6">
          <!-- <app-video-count></app-video-count> -->
          <app-recent-videos></app-recent-videos>
        </div>
        <div class="lg:col-span-1 flex flex-col gap-6">
          <app-favorites></app-favorites>
          <app-recent-documents></app-recent-documents>
        </div>
      </div>
    </div>
  </div>
</main>